<div class="extraction-detail-main-container overflow-auto">
  <div class="flex align-items-center justify-content-between w-full">
    <div class="flex align-items-center">
      <div
        class="bg-primary-100 p-2 border-circle flex align-items-center justify-content-center"
      >
        <svg-icon key="svg-extraction" class="text-primary"></svg-icon>
      </div>
      <span class="text-sm font-medium ml-2">Entities</span>
    </div>
    <div class="flex align-items-center gap-2">
      <p-button
        type="button"
        rounded="true"
        outlined="true"
        styleClass="h-2rem text-sm flex justify-content-center"
        [disabled]="!hasEntities()"
        (click)="
          $event.stopPropagation();
          $event.stopImmediatePropagation();
          downloadMenu.toggle($event)
        "
      >
        <i class="pi pi-download text-xs mr-2"></i>Download
      </p-button>
      <p-menu #downloadMenu [model]="downloadItems" [popup]="true" appendTo="body"></p-menu>
      @if (!_extraction.isEditEntities) {
      <p-button
        type="button"
        rounded="true"
        styleClass="h-2rem text-sm flex justify-content-center"
        (click)="
          $event.stopPropagation();
          $event.stopImmediatePropagation();
          _extraction.isEditEntities = true
        "
      >
        <i class="pi pi-pencil text-xs mr-2"></i>Edit
      </p-button>
      }@else {

      <p-button
        type="button"
        rounded="true"
        styleClass="h-2rem text-sm flex justify-content-center"
        (click)="
          $event.stopPropagation();
          $event.stopImmediatePropagation();
          saveContract()
        "
      >
        @if (isSaving) {
        <i class="pi pi-spin pi-spinner text-xs mr-2"></i>
        }@else {
        <i class="pi pi-check text-xs mr-2"></i>
        } Save
      </p-button>
      }
      <p-button
        type="button"
        rounded="true"
        text="true"
        plain="true"
        styleClass="h-2rem w-2rem p-0 m-0 text-sm flex justify-content-center"
        (click)="
          $event.stopPropagation(); $event.stopImmediatePropagation(); close()
        "
      >
        <i class="pi pi-times text-xs"></i>
      </p-button>
    </div>
  </div>
  <div class="pr-5 mt-3">
    <p-iconField iconPosition="right">
      @if (searchQuery == '') {
      <p-inputIcon styleClass="pi pi-search" />
      }@else {
      <p-inputIcon
        styleClass="pi pi-times cursor-pointer"
        (click)="searchQuery = ''; filterEntries()"
      />
      }

      <input
        type="text"
        [(ngModel)]="searchQuery"
        (ngModelChange)="filterEntries()"
        class="p-inputtext p-component w-full h-2rem text-sm"
        pInputText
        placeholder="Search entities"
      />
    </p-iconField>
  </div>
  <div
    class="w-full px-1 mt-3 overflow-auto"
    [style]="{ 'max-height': maxHeight }"
  >
    <app-entity-viewer
      [entities]="filteredEntries"
      [saveContract]="saveContract"
    ></app-entity-viewer>
  </div>
</div>
